export default {
  'components.dtrp.quarter': {
    ko: '분기',
    ja: '四半期',
    en: 'Quarter',
    cn: '',
  },
  'components.tn.moreNext': {
    ko: '더 이후',
    ja: 'もっと次へ',
    en: 'More Next',
    cn: '',
  },
  'components.dtrn.moreNext': {
    ko: '한시간 이후',
    ja: '1時間後',
    en: 'After an hour',
    cn: '',
  },
  'components.dtrn.morePrevious': {
    ko: '한시간 이전',
    ja: '1時間前',
    en: 'An hour ago',
    cn: '',
  },
  'components.dtrp.year': {
    ko: '년',
    ja: '年',
    en: 'Year',
    cn: '',
  },
  'cmpnt.title.loadgen': {
    ko: 'Load-Gen',
    ja: 'Load-Gen',
    en: 'Load-Gen',
    cn: '',
  },
  'cmpnt.title.proc': {
    ko: 'Processing',
    ja: '処理中',
    en: 'Processing',
    cn: '',
  },
  'components.dtrn.previous': {
    ko: '10분 이전',
    ja: '10分前',
    en: '10 minutes ago',
    cn: '',
  },
  'cmpnt.hms.format.error': {
    ko: '입력된 시각 형식(HH:MM:SS)가 잘못되었습니다.',
    ja: '入力された時間形式(HH:MM:SS)が不正です。',
    en: 'Invalidatted time format (HH:MM:SS) was input.',
    cn: '',
  },
  'components.dtrn.next': {
    ko: '십분 이후',
    ja: '10分後',
    en: 'After 10 minutes',
    cn: '',
  },
  'cmpnt.title.db': {
    ko: 'DB',
    ja: 'DB',
    en: 'DB',
    cn: '',
  },
  'components.tn.stop': {
    ko: '중지',
    ja: '停止',
    en: 'Stop',
    cn: '',
  },
  'components.dtrp.day': {
    ko: '일',
    ja: '日',
    en: 'Day',
    cn: '',
  },
  'cmpnt.ymd.format.error': {
    ko: '입력된 날짜 형식(YYYY-MM-DD)가 잘못되었습니다.',
    ja: '入力された日付形式(YYYY-MM-DD)が不正です。',
    en: 'Invalidatted date format (YYYY-MM-DD) was input.',
    cn: '',
  },
  'cmpnt.title.rollwait': {
    ko: 'Roll Wait',
    ja: 'ロール待機',
    en: 'Roll Wait',
    cn: '',
  },
  'components.tn.play': {
    ko: '시작',
    ja: '開始',
    en: 'Play',
    cn: '',
  },
  'cmpnt.title.enq.lock': {
    ko: 'Enqueue Lock',
    ja: 'エンキューロック',
    en: 'Enqueue Lock',
    cn: '',
  },
  'cmpnt.begin.dt': {
    ko: '시작 일시',
    ja: '開始日時',
    en: 'Begin time',
    cn: '',
  },
  'components.tn.next': {
    ko: '이후',
    ja: '以降',
    en: 'Next',
    cn: '',
  },
  'components.dtrp.week': {
    ko: '주',
    ja: '週',
    en: 'Week',
    cn: '',
  },
  'cmpnt.title.disp.wait': {
    ko: 'Dispatcher Wait',
    ja: 'ディスパッチャ待機',
    en: 'Dispatcher Wait',
    cn: '',
  },
  'components.dtrp.month': {
    ko: '월',
    ja: '月',
    en: 'Month',
    cn: '',
  },
  'components.tn.previous': {
    ko: '이전',
    ja: '前へ',
    en: 'Previous',
    cn: '',
  },
  'components.tn.morePrevious': {
    ko: '더 이전',
    ja: 'もっと前へ',
    en: 'More Previous',
    cn: '',
  },
  'cmpnt.title.rollin': {
    ko: 'Roll-in',
    ja: 'ロールイン',
    en: 'Roll-in',
    cn: '',
  },
  'cmpnt.input.required': {
    ko: '입력이 필요합니다.',
    ja: '入力が必要です。',
    en: 'Input required',
    cn: '',
  },
  'cmpnt.end.dt': {
    ko: '종료 일시',
    ja: '終了日時',
    en: 'End time',
    cn: '',
  },
};
